export default "__VITE_ASSET__8cf0d649__"